import { render, staticRenderFns } from "./CorporateUserResetPasswordView.vue?vue&type=template&id=3287ca2c&"
import script from "./CorporateUserResetPasswordView.vue?vue&type=script&lang=js&"
export * from "./CorporateUserResetPasswordView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports